import { Building, Truck, Users } from "lucide-react";
import { FilterLiveForm, useGetIdentity, useTranslate } from "ra-core";

import { ToggleFilterButton, SearchInput } from "@/components/admin";
import { FilterCategory } from "../filters/FilterCategory";
import { useConfigurationContext } from "../root/ConfigurationContext";
import { sizes } from "./sizes";

export const CompanyListFilter = () => {
  const { identity } = useGetIdentity();
  const { companySectors } = useConfigurationContext();
  const translate = useTranslate();
  
  const sectors = companySectors.map((sector) => ({
    id: sector,
    name: sector,
  }));
  
  return (
    <div className="w-52 min-w-52 flex flex-col gap-8">
      <FilterLiveForm>
        <SearchInput source="q" />
      </FilterLiveForm>

      <FilterCategory icon={<Building className="h-4 w-4" />} label={translate("simplecrm.companies.size", { _: "Tamanho" })}>
        {sizes.map((size) => (
          <ToggleFilterButton
            className="w-full justify-between"
            label={size.name}
            value={{ size: size.id }}
          />
        ))}
      </FilterCategory>

      <FilterCategory icon={<Truck className="h-4 w-4" />} label={translate("simplecrm.companies.sector", { _: "Setor" })}>
        {sectors.map((sector) => (
          <ToggleFilterButton
            className="w-full justify-between"
            label={sector.name}
            value={{ sector: sector.id }}
          />
        ))}
      </FilterCategory>

      <FilterCategory
        icon={<Users className="h-4 w-4" />}
        label={translate("simplecrm.companies.account_manager", { _: "Gerente de Conta" })}
      >
        <ToggleFilterButton
          className="w-full justify-between"
          label={translate("simplecrm.companies.me", { _: "Eu" })}
          value={{ sales_id: identity?.id }}
        />
      </FilterCategory>
    </div>
  );
};
